/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import StepChanger from '../StepChanger/StepChanger'
import { Form, Row, Col, Typography } from 'antd'
import { CustomTextInput, CustomPasswordInput, CustomConfirmPasswordInput } from 'src/components'
import styles from './CredentialsFormStep.module.scss'
import { setUserRegisterButtonStepValue, setUserFormCredentials } from 'src/features'
import { UserCredentials } from 'src/core/models'
const { Title, Text } = Typography

const CredentialsFormStep = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const userCredentials = useAppSelector((state) => state.users.registerForm.credentials)

  const onFinish = (userCredentials: UserCredentials) => {
    dispatch(setUserRegisterButtonStepValue(1))
    dispatch(setUserFormCredentials(userCredentials))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['email']: userCredentials.email,
      ['phone']: userCredentials.phone,
      ['password']: userCredentials.password,
      ['confirmPassword']: userCredentials.confirmPassword,
    })
  }, [userCredentials])

  return (
    <>
      <Form
        name='credentialsForm'
        onFinish={onFinish}
        autoComplete='off'
        className='mt-3'
        form={form}
      >
        <Row>
          <Col xs={24} lg={12} className={styles['padding-col']}>
            {/* Email */}
            <Title level={5} type='secondary' className={styles['label-text']}>{t('admin.Brokerage.Email')}</Title>
            <CustomTextInput
              name={'email'}
              placeholder={t('admin.Brokerage.EmailPlaceHolder')}
              type='email'
              required
            />
          </Col>
          <Col xs={24} lg={12} className={styles['padding-col']}>
            {/* Phone */}
            <Title level={5} type='secondary' className={styles['label-text']}>{t('admin.Brokerage.Phone')}</Title>
            <CustomTextInput
              name={'phone'}
              placeholder={t('admin.Brokerage.PhonePlaceHolder')}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={24} lg={12} className={styles['padding-col']}>
            {/* Email */}
            <Title level={5} type='secondary' className={styles['label-text']}>
              {t('admin.Brokerage.Password')}
            </Title>
            <CustomPasswordInput
              name={'password'}
              placeholder={t('admin.Brokerage.PasswordPlaceHolder')}
              type='password'
              required
            />
            <Text type='secondary'>
              {t('admin.Brokerage.PassValLabel')}
            </Text>
          </Col>
          <Col xs={24} lg={12} className={styles['padding-col']}>
            {/* Confirm Passowrd */}
            <Title level={5} type='secondary' className={styles['label-text']}>{t('admin.Brokerage.ComfirmPassowrd')}</Title>
            <CustomConfirmPasswordInput
              name={'confirmPassword'}
              placeholder={t('admin.Brokerage.ComfirmPassowrdPlaceHolder')}
            />
          </Col>
        </Row>

        {/* Buttons Content */}
        <StepChanger nextStepValue={1} />
      </Form>
    </>
  )
}

export default CredentialsFormStep
